import MDBox from "components/MDBox"
import MDButton from "components/MDButton";
import TableSkeleton from "components/TableSkeleton";
import { useEffect, useMemo, useState } from "react"
import { useMaterialUIController, setLoading } from "context";
import { useForm } from "react-hook-form";
import DataTable from "examples/Tables/DataTable";
import permissions from "permissions";
import { CircularProgress } from "@mui/material";
import { ConsumptionHistoryAPI } from "api/ConsumptionHistoryAPI";



export default function ConsumptionHistoryTable(props) {

  const [consumptionHistory, setConsumptionHistory] = useState([]);
  const [controller, dispatch] = useMaterialUIController();
  const { user, loading, admin } = controller;
  const { handleSubmit, formState: { isSubmitting } } = useForm();
  const { handleAlert } = props


  const currencyformatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
  });

  const numberFormater = new Intl.NumberFormat();

  const renderConsumptionHistory = useMemo(() => {
    let rows = [];
    const columns = [
      { Header: "Producto", accessor: "producto", align: "right" },
      { Header: "Descripcion", accessor: "descripcion", align: "left", },
      { Header: "Cantidad", accessor: "cantidad", align: "right" },
      { Header: "Valor Unitario", accessor: "valor_unitario", align: "right" },
      { Header: "Valor Total", accessor: "valor_total", align: "right" },
      { Header: "Fecha", accessor: "fecha", align: "left", },
    ];

    consumptionHistory?.map((element) => {
      rows = [...rows,
      {
        producto: element.codigo,
        descripcion: element.descripcion,
        cantidad: element.cantidad,
        valor_unitario: currencyformatter.format(Number(element.valor_unitario).toFixed(2)),
        valor_total: currencyformatter.format(Number(element.valor_total).toFixed(2)),
        fecha: element.fecha,
      }]
    });

    return (<DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={true}
      showTotalEntries={true}
      noEndBorder
      canSearch={true}
    />
    );
  }, [consumptionHistory])


  const getConsumptionHistory = () => {
    setLoading(dispatch, true)
    return ConsumptionHistoryAPI.index(true)
      .then(response => {
        setConsumptionHistory(response.consumption_history)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }


  return (
    <MDBox>
      <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', p: 3 }} component="form" role="form" onSubmit={handleSubmit(getConsumptionHistory)}>
        {(user?.permissions?.includes(permissions.product_arrays[1]) || user?.role === admin) && (
          <MDButton type="submit" variant="gradient" color="info" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Consultar Historial de Consumo'}
          </MDButton>
        )}
      </MDBox>
      <MDBox>
        {loading ? <TableSkeleton></TableSkeleton> : renderConsumptionHistory}
      </MDBox>
    </MDBox>
  )

}